import { render } from "./DetalharAnimal.vue?vue&type=template&id=49388708&scoped=true"
import script from "./DetalharAnimal.vue?vue&type=script&lang=js"
export * from "./DetalharAnimal.vue?vue&type=script&lang=js"

import "./DetalharAnimal.vue?vue&type=style&index=0&id=49388708&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49388708"]])

export default __exports__